import { useQuery } from 'react-query'
import type { FolderBreadcrumb } from '@dc-shared-web/hooks/api/folder/types'
import { fetchFoldersById } from '@dc-shared-web/hooks/api/folder/fetchFoldersById'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'

const QUERY_KEY = ['folder']

export const useGetFolderById = (
  currentTeamUuid: string,
  folderUuid: string,
  enabled: boolean = true
) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<FolderBreadcrumb, Error>(
    [...QUERY_KEY, currentTeamUuid, folderUuid],
    () => fetchFoldersById(apiClient, { currentTeamUuid, folderUuid }),
    {
      enabled: !!currentTeamUuid && !!folderUuid && enabled,
    }
  )
}
